import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorResponse } from 'src/app/models/error.model';
import { Comercial } from 'src/app/models/comercial.model';
import { UsuarioSimple } from 'src/app/models/usuario-simple.model';
import { ComercialesService } from 'src/app/services/comerciales.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-edit-comercial',
    templateUrl: './edit-comercial.component.html',
    styleUrls: ['./edit-comercial.component.scss']
})
export class EditComercialComponent implements OnInit {

    comercial?: Comercial;
    usuarioEncontrado?: UsuarioSimple;
    buscandoUsuario = false;

    emailBusqueda = new UntypedFormControl('', [Validators.required, Validators.email]);

    form = new UntypedFormGroup({
        nombre: new UntypedFormControl('', [Validators.required]),
        apellido: new UntypedFormControl('', [Validators.required]),
        telefono: new UntypedFormControl(''),
        activo: new UntypedFormControl(true, [Validators.required])
    });

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private comercialesService: ComercialesService,
        private usuariosService: UsuariosService,
        private utilsService: UtilsService
    ) { }

    get editMode() { return !!this.comercial; }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params?.id) {
                this.comercialesService.getComercialById(params.id).subscribe({
                    next: comercial => {
                        this.comercial = comercial;
                        this.form.setValue({
                            nombre: comercial.nombre,
                            apellido: comercial.apellido,
                            telefono: comercial.telefono ?? '',
                            activo: comercial.activo
                        });
                    },
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener el comercial', error.error?.descripcion)
                });
            }
        });
    }

    buscarUsuario() {
        if (this.emailBusqueda.invalid) {
            this.emailBusqueda.markAsTouched();
            return;
        }
        this.buscandoUsuario = true;
        this.usuarioEncontrado = undefined;
        this.usuariosService.buscarPorEmail(this.emailBusqueda.value).subscribe({
            next: response => {
                this.buscandoUsuario = false;
                if (response.status === 204 || !response.body) {
                    this.utilsService.alert('Usuario no encontrado', `No existe un usuario con el email "${this.emailBusqueda.value}".`);
                } else {
                    this.usuarioEncontrado = response.body;
                }
            },
            error: (error: ErrorResponse) => {
                this.buscandoUsuario = false;
                this.utilsService.alert('Error al buscar el usuario', error.error?.descripcion);
            }
        });
    }

    save() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        if (this.editMode) {
            const payload: Comercial = {
                ...this.comercial,
                nombre: this.form.value.nombre,
                apellido: this.form.value.apellido,
                telefono: this.form.value.telefono || null,
                activo: this.form.value.activo
            };
            this.comercialesService.updateComercial(payload).subscribe({
                next: () => {
                    this.utilsService.alert('Comercial actualizado', `"${payload.nombre} ${payload.apellido}" fue actualizado correctamente.`);
                    this.router.navigate(['comerciales']);
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al actualizar el comercial', error.error?.descripcion)
            });
        } else {
            if (!this.usuarioEncontrado) {
                this.utilsService.alert('Usuario requerido', 'Debe buscar y seleccionar un usuario antes de crear el comercial.');
                return;
            }
            const payload: Comercial = {
                idUsuario: this.usuarioEncontrado.id,
                nombre: this.form.value.nombre,
                apellido: this.form.value.apellido,
                telefono: this.form.value.telefono || null,
                activo: true
            };
            this.comercialesService.createComercial(payload).subscribe({
                next: () => {
                    this.utilsService.alert('Comercial creado', `"${payload.nombre} ${payload.apellido}" fue creado correctamente.`);
                    this.router.navigate(['comerciales']);
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al crear el comercial', error.error?.descripcion)
            });
        }
    }

    cancel() {
        this.router.navigate(['comerciales']);
    }
}
